import NumberValue from '@/components/tableElements/NumberValue.vue';
export default {
  name: 'HashedNumberValue',
  components: {
    NumberValue
  },
  props: {
    value: Number,
    hashColor: {
      type: String,
      default: '#BFBFBF'
    },
    charCount: Number,
    prepend: {
      type: String,
      default: '#'
    }
  }
};